import axios from 'axios';
import API_BASE_URL from './api';

const API = `${API_BASE_URL}/api`;

const getAuthHeader = () => {
  try {
    const userToken = localStorage.getItem('padaid_user_token');
    const adminToken = localStorage.getItem('padaid_admin_token');
    const token = userToken || adminToken;
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch (e) {
    return {};
  }
};

// Public
export const getPublicFAQ = async (lang = 'fr') => {
  const res = await axios.get(`${API}/faq`, { params: { lang } });
  return res.data;
};

export const searchPublicFAQ = async (q, lang = 'fr', limit = 20, offset = 0) => {
  const res = await axios.get(`${API}/faq/search`, { params: { q, lang, limit, offset } });
  return res.data;
};

// Admin
export const getFaqLanguages = async () => {
  const res = await axios.get(`${API}/admin/faq/languages`, { headers: getAuthHeader() });
  return res.data;
};

export const listCategories = async () => {
  const res = await axios.get(`${API}/admin/faq/categories`, { headers: getAuthHeader() });
  return res.data;
};

export const createCategory = async (payload) => {
  const res = await axios.post(`${API}/admin/faq/categories`, payload, { headers: getAuthHeader() });
  return res.data;
};

export const updateCategory = async (categoryId, payload) => {
  const res = await axios.put(`${API}/admin/faq/categories/${categoryId}`, payload, { headers: getAuthHeader() });
  return res.data;
};

export const deleteCategory = async (categoryId) => {
  const res = await axios.delete(`${API}/admin/faq/categories/${categoryId}`, { headers: getAuthHeader() });
  return res.data;
};

export const reorderCategories = async (order) => {
  const res = await axios.post(`${API}/admin/faq/categories/reorder`, { order }, { headers: getAuthHeader() });
  return res.data;
};

export const translateCategory = async (categoryId, targetLanguages) => {
  const res = await axios.post(`${API}/admin/faq/categories/translate`, { category_id: categoryId, target_languages: targetLanguages }, { headers: getAuthHeader() });
  return res.data;
};

export const translateAllCategories = async (targetLanguages) => {
  const res = await axios.post(`${API}/admin/faq/categories/translate-all`, { target_languages: targetLanguages }, { headers: getAuthHeader() });
  return res.data;
};

export const listItems = async (categoryId, q) => {
  const params = {};
  if (categoryId) params.category_id = categoryId;
  if (q) params.q = q;
  const res = await axios.get(`${API}/admin/faq/items`, { params, headers: getAuthHeader() });
  return res.data;
};

export const createItem = async (payload) => {
  const res = await axios.post(`${API}/admin/faq/items`, payload, { headers: getAuthHeader() });
  return res.data;
};

export const updateItem = async (itemId, payload) => {
  const res = await axios.put(`${API}/admin/faq/items/${itemId}`, payload, { headers: getAuthHeader() });
  return res.data;
};

export const deleteItem = async (itemId) => {
  const res = await axios.delete(`${API}/admin/faq/items/${itemId}`, { headers: getAuthHeader() });
  return res.data;
};

export const bulkPublishItems = async (ids, published) => {
  const res = await axios.post(`${API}/admin/faq/items/bulk-publish`, { ids, published }, { headers: getAuthHeader() });
  return res.data;
};

export const translateItem = async (itemId, targetLanguages) => {
  const res = await axios.post(`${API}/admin/faq/items/translate`, { item_id: itemId, target_languages: targetLanguages }, { headers: getAuthHeader() });
  return res.data;
};

export const reorderItems = async (categoryId, order) => {
  const res = await axios.post(`${API}/admin/faq/items/reorder`, { category_id: categoryId, order }, { headers: getAuthHeader() });
  return res.data;
};

export const translateAllItems = async (targetLanguages, categoryId) => {
  const payload = { target_languages: targetLanguages };
  if (categoryId) payload.category_id = categoryId;
  const res = await axios.post(`${API}/admin/faq/items/translate-all`, payload, { headers: getAuthHeader() });
  return res.data;
};